// const { forEach } = require("lodash");

angular.module('inspecciones')
    .controller('inspeccionesTunelADIFController', [
        '$scope',
        '$rootScope',
        '$routeParams',
        '$location',
        '$q',
        '$timeout',
        'inspeccionesService',
        'infraestructurasService',
        'authenticationInfo',
        'authenticationService',
        function (
            $scope,
            $rootScope,
            $routeParams,
            $location,
            $q,
            $timeout,
            inspeccionesService,
            infraestructurasService,
            authenticationInfo,
            authenticationService
        ) {
            $scope.authentication = authenticationInfo;

            // Pestaña seleccionada al entrar en el túnel.
            $scope.pestanaActiva = 'inspecciones';

            $scope.seleccionarPestana = function (pestana) {
                $scope.pestanaActiva = pestana;
            };

            var tunelADIFId = $routeParams.id;
            var graficoGravedadDiagnostico = null;
            var graficoTiposDiagnostico = null;
            var graficoElementosDiagnostico = null;
            var chartJsDiagnosticoCargando = false;
            var callbacksChartJsDiagnostico = [];

            $scope.diagnosticoIndividual = crearDiagnosticoVacio();
            $scope.errorGraficoGravedadDiagnostico = false;
            $scope.estadoGraficoTiposDiagnostico = crearEstadoGrafico();
            $scope.estadoGraficoElementosDiagnostico = crearEstadoGrafico();
            $scope.distribucionLongitudinal = crearDistribucionLongitudinalVacia();
            cargarDatosTunel();

            $scope.$watch('pestanaActiva', function (pestana) {
                if (pestana === 'diagnostico') {
                    programarGraficosDiagnostico();
                }
            });

            $scope.$on('$destroy', function () {
                destruirGrafico(graficoGravedadDiagnostico);
                destruirGrafico(graficoTiposDiagnostico);
                destruirGrafico(graficoElementosDiagnostico);
            });

            function crearEstadoGrafico() {
                return {
                    cargando: false,
                    error: false,
                    hayDatos: false,
                    totalDanios: 0,
                    totalGrupos: 0,
                    datos: []
                };
            }

            function crearDistribucionLongitudinalVacia() {
                return {
                    cargando: false,
                    error: false,
                    hayDatos: false,
                    pkInicio: '',
                    pkFin: '',
                    longitud: 0,
                    marcas: [],
                    escala: [],
                    totalN1: 0,
                    totalN2: 0,
                    totalN3: 0,
                    totalN4: 0
                };
            }

            function crearDiagnosticoVacio() {
                return {
                    cargando: true,
                    error: false,
                    hayInspeccion: false,
                    hayInspeccionAnterior: false,
                    totalDanios: 0,
                    totalN1: 0,
                    totalN2: 0,
                    totalN3: 0,
                    totalN4: 0,
                    variacionPorcentaje: null,
                    variacionDanios: null,
                    daniosPorKm: 0,
                    longitud: 0,
                    fechaUltimaInspeccion: null,
                    numeroTramos: 0
                };
            }

            function cargarDatosTunel() {
                $scope.diagnosticoIndividual = crearDiagnosticoVacio();

                return $q.all({
                    tunel: infraestructurasService.getTunelADIF(tunelADIFId),
                    inspecciones: inspeccionesService.getInspeccionesTunelADIF(tunelADIFId)
                }).then(function (responses) {
                    $scope.tunelADIF = responses.tunel.data;
                    $scope.inspecciones = responses.inspecciones.data || [];

                    if ($scope.inspecciones.length === 0) {
                        $scope.diagnosticoIndividual.cargando = false;
                        return;
                    }

                    prepararUltimaInspeccion($scope.inspecciones[0]);

                    return cargarDiagnosticoIndividual(
                        $scope.inspecciones[0],
                        $scope.inspecciones.length > 1
                            ? $scope.inspecciones[1]
                            : null
                    );
                }).catch(function (error) {
                    $scope.diagnosticoIndividual.cargando = false;
                    $scope.diagnosticoIndividual.error = true;
                    console.error(
                        'No se ha podido cargar el diagnóstico individual del túnel.',
                        error
                    );
                });
            }

            function prepararUltimaInspeccion(inspeccion) {
                $scope.ultimainspeccion = {
                    Id: inspeccion.Id,
                    fechafin: inspeccion.FechaFin,
                    fechaInicio: inspeccion.FechaInicio,
                    InspectorDescripcion: inspeccion.Inspector
                        ? inspeccion.Inspector.Descripcion
                        : '',
                    InspectorId: inspeccion.Inspector
                        ? inspeccion.Inspector.Id
                        : null,
                    PropietarioDescripcion: inspeccion.Propietario
                        ? inspeccion.Propietario.Descripcion
                        : '',
                    PropietarioId: inspeccion.Propietario
                        ? inspeccion.Propietario.Id
                        : null
                };
            }

            function cargarDiagnosticoIndividual(inspeccionActual, inspeccionAnterior) {
                var peticionActual =
                    infraestructurasService.getDañosADIFPorGravedad(
                        inspeccionActual.Id
                    );

                var peticionAnterior = inspeccionAnterior
                    ? infraestructurasService.getDañosADIFPorGravedad(
                        inspeccionAnterior.Id
                    )
                    : $q.when({ data: null });

                return $q.all({
                    actual: peticionActual,
                    anterior: peticionAnterior
                }).then(function (responses) {
                    var actual = obtenerConteosPorGravedad(
                        responses.actual.data
                    );
                    var anterior = obtenerConteosPorGravedad(
                        responses.anterior.data
                    );

                    var totalActual =
                        actual.n1 + actual.n2 + actual.n3 + actual.n4;
                    var totalAnterior =
                        anterior.n1 + anterior.n2 + anterior.n3 + anterior.n4;
                    var longitud = convertirNumero(
                        $scope.tunelADIF && $scope.tunelADIF.Longitud
                    );
                    var longitudKm = longitud > 0
                        ? longitud / 1000
                        : 0;
                    var diferencia = inspeccionAnterior
                        ? totalActual - totalAnterior
                        : null;
                    var porcentaje = null;

                    if (inspeccionAnterior) {
                        if (totalAnterior > 0) {
                            porcentaje = diferencia / totalAnterior * 100;
                        } else {
                            porcentaje = totalActual > 0 ? 100 : 0;
                        }
                    }

                    $scope.diagnosticoIndividual = {
                        cargando: false,
                        error: false,
                        hayInspeccion: true,
                        hayInspeccionAnterior: !!inspeccionAnterior,
                        totalDanios: totalActual,
                        totalN1: actual.n1,
                        totalN2: actual.n2,
                        totalN3: actual.n3,
                        totalN4: actual.n4,
                        variacionPorcentaje: porcentaje,
                        variacionDanios: diferencia,
                        daniosPorKm: longitudKm > 0
                            ? totalActual / longitudKm
                            : 0,
                        longitud: longitud,
                        fechaUltimaInspeccion: inspeccionActual.FechaInicio,
                        numeroTramos: Number(inspeccionActual.NumTramos) || 0
                    };

                    programarGraficosDiagnostico();
                    cargarGraficosDiagnostico(inspeccionActual.Id);
                });
            }

            function cargarGraficosDiagnostico(idInspeccion) {
                cargarDistribucionLongitudinal(idInspeccion);

                cargarResumenGrafico(
                    infraestructurasService.getDañosADIFPorTipo(idInspeccion),
                    'Tipo',
                    'Sin tipo informado',
                    'estadoGraficoTiposDiagnostico'
                );

                cargarResumenGrafico(
                    infraestructurasService.getDañosADIFPorElemento(idInspeccion),
                    'Elemento',
                    'Sin elemento informado',
                    'estadoGraficoElementosDiagnostico'
                );
            }

            function cargarDistribucionLongitudinal(idInspeccion) {
                $scope.distribucionLongitudinal =
                    crearDistribucionLongitudinalVacia();
                $scope.distribucionLongitudinal.cargando = true;

                inspeccionesService.getDañosADIF(idInspeccion)
                    .then(function (response) {
                        var danos = angular.isArray(response.data)
                            ? response.data
                            : [];
                        var tunel = $scope.tunelADIF || {};
                        var pkInicioTunel = convertirPkAMetros(
                            tunel.PkInicial !== undefined
                                ? tunel.PkInicial
                                : (tunel.PKInicial !== undefined
                                    ? tunel.PKInicial
                                    : tunel.PkInicio)
                        );
                        var pkFinTunel = convertirPkAMetros(
                            tunel.PkFinal !== undefined
                                ? tunel.PkFinal
                                : (tunel.PKFinal !== undefined
                                    ? tunel.PKFinal
                                    : tunel.PkFin)
                        );
                        var pkInicio = pkInicioTunel;
                        var pkFin = pkFinTunel;
                        var longitud = Number(
                            $scope.diagnosticoIndividual.longitud
                        ) || 0;
                        var posiciones = danos.map(function (dano) {
                            return convertirPkAMetros(
                                dano.PkDano !== undefined
                                    ? dano.PkDano
                                    : (dano.PkDaño !== undefined
                                        ? dano.PkDaño
                                        : (dano.PK !== undefined
                                            ? dano.PK
                                            : dano.Pk))
                            );
                        }).filter(function (pk) {
                            return pk !== null;
                        });

                        if (pkInicio === null && posiciones.length > 0) {
                            pkInicio = Math.min.apply(Math, posiciones);
                        }

                        if (pkFin === null && pkInicio !== null && longitud > 0) {
                            pkFin = pkInicio + longitud;
                        }

                        if (pkFin === null && posiciones.length > 0) {
                            pkFin = Math.max.apply(Math, posiciones);
                        }

                        if (pkInicio === null && pkFin !== null && longitud > 0) {
                            pkInicio = pkFin - longitud;
                        }

                        if (pkInicio === null) {
                            pkInicio = 0;
                        }

                        if (pkFin === null || pkFin === pkInicio) {
                            pkFin = pkInicio + (longitud > 0 ? longitud : 1);
                        }

                        var recorrido = pkFin - pkInicio;

                        if (longitud <= 0) {
                            longitud = Math.abs(recorrido);
                        }

                        var conteos = {
                            n1: 0,
                            n2: 0,
                            n3: 0,
                            n4: 0
                        };
                        var marcas = [];

                        angular.forEach(danos, function (dano) {
                            var pk = convertirPkAMetros(
                                dano.PkDano !== undefined
                                    ? dano.PkDano
                                    : (dano.PkDaño !== undefined
                                        ? dano.PkDaño
                                        : (dano.PK !== undefined
                                            ? dano.PK
                                            : dano.Pk))
                            );
                            var nivel = obtenerNivelGravedad(
                                dano.Gravedad ||
                                dano.GravedadDaño ||
                                dano.GravedadDano
                            );

                            if (pk === null || !nivel) {
                                return;
                            }

                            var porcentaje = recorrido !== 0
                                ? (pk - pkInicio) / recorrido * 100
                                : 0;

                            porcentaje = Math.max(0, Math.min(100, porcentaje));
                            var distanciaAlCentro = Math.abs(
                                porcentaje - 50
                            ) / 50;
                            var alturaPerspectiva = 26 +
                                distanciaAlCentro * 42;
                            conteos[nivel.clave] += 1;
                            marcas.push({
                                porcentaje: porcentaje,
                                color: nivel.color,
                                nivel: nivel.texto,
                                pk: formatearPkLongitudinal(pk),
                                alturaPerspectiva: alturaPerspectiva,
                                superiorPerspectiva:
                                    (72 - alturaPerspectiva) / 2
                            });
                        });

                        marcas.sort(function (a, b) {
                            if (a.porcentaje !== b.porcentaje) {
                                return a.porcentaje - b.porcentaje;
                            }

                            return a.nivel.localeCompare(b.nivel, 'es');
                        });

                        var escala = [];

                        for (var indice = 0; indice <= 4; indice++) {
                            var fraccion = indice / 4;
                            escala.push({
                                porcentaje: fraccion * 100,
                                texto: $scope.formatearNumero(
                                    longitud * fraccion,
                                    0
                                ) + (indice === 4 ? ' m' : '')
                            });
                        }

                        $scope.distribucionLongitudinal = {
                            cargando: false,
                            error: false,
                            hayDatos: marcas.length > 0,
                            pkInicio: formatearPkLongitudinal(pkInicioTunel),
                            pkFin: formatearPkLongitudinal(pkFinTunel),
                            longitud: longitud,
                            marcas: marcas,
                            escala: escala,
                            totalN1: conteos.n1,
                            totalN2: conteos.n2,
                            totalN3: conteos.n3,
                            totalN4: conteos.n4
                        };
                    })
                    .catch(function (error) {
                        $scope.distribucionLongitudinal =
                            crearDistribucionLongitudinalVacia();
                        $scope.distribucionLongitudinal.error = true;

                        console.error(
                            'No se ha podido cargar la distribución longitudinal.',
                            error
                        );
                    });
            }

            function obtenerNivelGravedad(gravedad) {
                var texto = gravedad && typeof gravedad === 'object'
                    ? (gravedad.Descripcion || gravedad.Nombre || '')
                    : gravedad;
                var normalizada = normalizarTexto(texto);

                if (normalizada === 'leve' || normalizada === 'n1') {
                    return { clave: 'n1', texto: 'N1', color: '#008000' };
                }

                if (normalizada === 'moderado' || normalizada === 'n2') {
                    return { clave: 'n2', texto: 'N2', color: '#FFD000' };
                }

                if (normalizada === 'severo' || normalizada === 'n3') {
                    return { clave: 'n3', texto: 'N3', color: '#FF8C00' };
                }

                if (normalizada === 'critico' || normalizada === 'n4') {
                    return { clave: 'n4', texto: 'N4', color: '#FF0000' };
                }

                return null;
            }

            function convertirPkAMetros(valor) {
                if (valor === null || valor === undefined || valor === '') {
                    return null;
                }

                if (typeof valor === 'number') {
                    return normalizarPkNumerico(valor);
                }

                var texto = String(valor).trim();
                var coincidencia = texto.match(
                    /^(-?\d+)\s*\+\s*(\d+(?:[.,]\d+)?)$/
                );

                if (coincidencia) {
                    return Number(coincidencia[1]) * 1000 +
                        Number(coincidencia[2].replace(',', '.'));
                }

                var numero = Number(
                    texto.replace(/\s/g, '').replace(',', '.')
                );

                return normalizarPkNumerico(numero);
            }

            function normalizarPkNumerico(numero) {
                if (!isFinite(numero)) {
                    return null;
                }

                /*
                 * Los PK de la ficha del túnel llegan habitualmente como
                 * kilómetros decimales: 277.466 equivale a PK 277+466.
                 * Los valores grandes ya están expresados en metros.
                 */
                return Math.abs(numero) < 10000
                    ? numero * 1000
                    : numero;
            }

            function formatearPkLongitudinal(valor) {
                var metros = Number(valor);

                if (!isFinite(metros)) {
                    return '—';
                }

                var signo = metros < 0 ? '-' : '';
                var absoluto = Math.abs(metros);
                var kilometros = Math.floor(absoluto / 1000);
                var resto = Math.round(absoluto - kilometros * 1000);

                if (resto === 1000) {
                    kilometros += 1;
                    resto = 0;
                }

                return signo + kilometros + '+' +
                    ('000' + String(resto)).slice(-3);
            }

            function cargarResumenGrafico(
                peticion,
                propiedad,
                textoPorDefecto,
                nombreEstado
            ) {
                $scope[nombreEstado] = crearEstadoGrafico();
                $scope[nombreEstado].cargando = true;

                peticion.then(function (response) {
                    var filas = angular.isArray(response.data)
                        ? response.data
                        : [];
                    var datos = filas.map(function (fila) {
                        var objeto = fila[propiedad];
                        var etiqueta = textoPorDefecto;

                        if (objeto && typeof objeto === 'object') {
                            etiqueta = objeto.Descripcion ||
                                objeto.descripcion ||
                                objeto.Nombre ||
                                objeto.nombre ||
                                textoPorDefecto;
                        } else if (objeto) {
                            etiqueta = objeto;
                        } else {
                            etiqueta = fila[propiedad + 'Descripcion'] ||
                                fila[propiedad.toLowerCase()] ||
                                textoPorDefecto;
                        }

                        return {
                            etiqueta: String(etiqueta),
                            total: Number(
                                fila.Conteo !== undefined
                                    ? fila.Conteo
                                    : (fila.Total !== undefined
                                        ? fila.Total
                                        : fila.total)
                            ) || 0
                        };
                    }).filter(function (fila) {
                        return fila.total > 0;
                    }).sort(function (a, b) {
                        if (b.total !== a.total) {
                            return b.total - a.total;
                        }

                        return a.etiqueta.localeCompare(b.etiqueta, 'es');
                    });

                    var totalDanios = datos.reduce(function (total, fila) {
                        return total + fila.total;
                    }, 0);
                    var principales = datos.slice(0, 8);

                    if (datos.length > 8) {
                        var otros = datos.slice(8).reduce(function (total, fila) {
                            return total + fila.total;
                        }, 0);

                        if (otros > 0) {
                            principales.push({
                                etiqueta: 'Otros',
                                total: otros
                            });
                        }
                    }

                    $scope[nombreEstado] = {
                        cargando: false,
                        error: false,
                        hayDatos: principales.length > 0,
                        totalDanios: totalDanios,
                        totalGrupos: datos.length,
                        datos: principales
                    };

                    programarGraficosDiagnostico();
                }).catch(function (error) {
                    $scope[nombreEstado] = crearEstadoGrafico();
                    $scope[nombreEstado].error = true;

                    console.error(
                        'No se ha podido cargar el gráfico ' + propiedad + '.',
                        error
                    );
                });
            }

            function programarGraficosDiagnostico() {
                if ($scope.pestanaActiva !== 'diagnostico') {
                    return;
                }

                $timeout(function () {
                    cargarChartJsDiagnostico(function () {
                        dibujarGraficoGravedadDiagnostico();
                        dibujarGraficoTiposDiagnostico();
                        dibujarGraficoElementosDiagnostico();
                    });
                }, 100);
            }

            function cargarChartJsDiagnostico(callback) {
                if (typeof window.Chart !== 'undefined') {
                    callback();
                    return;
                }

                callbacksChartJsDiagnostico.push(callback);

                if (chartJsDiagnosticoCargando) {
                    return;
                }

                chartJsDiagnosticoCargando = true;

                var urlsChartJs = [
                    'https://cdn.jsdelivr.net/npm/chart.js@4.4.7/dist/chart.umd.min.js',
                    'https://cdnjs.cloudflare.com/ajax/libs/Chart.js/4.4.7/chart.umd.min.js'
                ];

                function finalizarCarga() {
                    chartJsDiagnosticoCargando = false;

                    var callbacks = callbacksChartJsDiagnostico.slice();
                    callbacksChartJsDiagnostico = [];

                    $timeout(function () {
                        angular.forEach(callbacks, function (funcion) {
                            funcion();
                        });
                    }, 0);
                }

                function marcarErrorCarga() {
                    chartJsDiagnosticoCargando = false;
                    callbacksChartJsDiagnostico = [];

                    $scope.estadoGraficoTiposDiagnostico.error = true;
                    $scope.estadoGraficoElementosDiagnostico.error = true;
                    $scope.errorGraficoGravedadDiagnostico = true;

                    console.error('No se ha podido cargar Chart.js.');
                }

                function intentarCargar(indice) {
                    if (indice >= urlsChartJs.length) {
                        marcarErrorCarga();
                        return;
                    }

                    var script = document.createElement('script');
                    script.src = urlsChartJs[indice];
                    script.async = true;

                    script.onload = function () {
                        if (typeof window.Chart === 'undefined') {
                            intentarCargar(indice + 1);
                            return;
                        }

                        finalizarCarga();
                    };

                    script.onerror = function () {
                        intentarCargar(indice + 1);
                    };

                    document.head.appendChild(script);
                }

                intentarCargar(0);
            }

            function dibujarGraficoGravedadDiagnostico() {
                destruirGrafico(graficoGravedadDiagnostico);
                graficoGravedadDiagnostico = null;

                var diagnostico = $scope.diagnosticoIndividual || {};
                var totalDanios = Number(diagnostico.totalDanios) || 0;

                if (totalDanios <= 0 || typeof window.Chart === 'undefined') {
                    return;
                }

                var canvas = document.getElementById(
                    'graficoGravedadDiagnostico'
                );

                if (!canvas) {
                    return;
                }

                var valores = [
                    Number(diagnostico.totalN4) || 0,
                    Number(diagnostico.totalN3) || 0,
                    Number(diagnostico.totalN2) || 0,
                    Number(diagnostico.totalN1) || 0
                ];

                $scope.errorGraficoGravedadDiagnostico = false;

                graficoGravedadDiagnostico = new window.Chart(
                    canvas.getContext('2d'),
                    {
                        type: 'doughnut',
                        data: {
                            labels: [
                                'N4',
                                'N3',
                                'N2',
                                'N1'
                            ],
                            datasets: [{
                                data: valores,
                                backgroundColor: [
                                    '#FF0000',
                                    '#FF8C00',
                                    '#FFD000',
                                    '#008000'
                                ],
                                borderColor: '#FFFFFF',
                                borderWidth: 2
                            }]
                        },
                        options: {
                            responsive: true,
                            maintainAspectRatio: false,
                            cutout: '62%',
                            plugins: {
                                legend: {
                                    display: true,
                                    position: 'right',
                                    labels: {
                                        boxWidth: 12,
                                        padding: 12,
                                        color: '#153e7e',
                                        font: {
                                            size: 11
                                        },
                                        generateLabels: function (chart) {
                                            var etiquetas = chart.data.labels;
                                            var datos = chart.data.datasets[0].data;
                                            var colores = chart.data.datasets[0]
                                                .backgroundColor;

                                            return etiquetas.map(function (
                                                etiqueta,
                                                indice
                                            ) {
                                                var cantidad = Number(
                                                    datos[indice]
                                                ) || 0;
                                                var porcentaje = totalDanios > 0
                                                    ? cantidad / totalDanios * 100
                                                    : 0;

                                                return {
                                                    text: etiqueta + '   ' +
                                                        $scope.formatearNumero(
                                                            cantidad,
                                                            0
                                                        ) + ' (' +
                                                        $scope.formatearNumero(
                                                            porcentaje,
                                                            0
                                                        ) + '%)',
                                                    fillStyle: colores[indice],
                                                    strokeStyle: colores[indice],
                                                    lineWidth: 0,
                                                    fontColor: '#153e7e',
                                                    hidden: false,
                                                    index: indice
                                                };
                                            });
                                        }
                                    }
                                },
                                tooltip: {
                                    callbacks: {
                                        label: function (context) {
                                            var cantidad = Number(context.raw) || 0;
                                            var porcentaje = totalDanios > 0
                                                ? cantidad / totalDanios * 100
                                                : 0;

                                            return context.label + ': ' +
                                                $scope.formatearNumero(cantidad, 0) +
                                                ' daños (' +
                                                $scope.formatearNumero(porcentaje, 1) +
                                                '%)';
                                        }
                                    }
                                }
                            }
                        },
                        plugins: [{
                            id: 'textoCentralGravedadDiagnostico',
                            afterDraw: function (chart) {
                                if (!chart.chartArea) {
                                    return;
                                }

                                var contexto = chart.ctx;
                                var centroX = (
                                    chart.chartArea.left + chart.chartArea.right
                                ) / 2;
                                var centroY = (
                                    chart.chartArea.top + chart.chartArea.bottom
                                ) / 2;

                                contexto.save();
                                contexto.textAlign = 'center';
                                contexto.textBaseline = 'middle';
                                contexto.fillStyle = '#153e7e';
                                contexto.font = 'bold 22px Arial';
                                contexto.fillText(
                                    $scope.formatearNumero(totalDanios, 0),
                                    centroX,
                                    centroY - 8
                                );
                                contexto.font = '11px Arial';
                                contexto.fillText(
                                    'daños',
                                    centroX,
                                    centroY + 13
                                );
                                contexto.restore();
                            }
                        }]
                    }
                );
            }

            function dibujarGraficoTiposDiagnostico() {
                destruirGrafico(graficoTiposDiagnostico);
                graficoTiposDiagnostico = crearGraficoBarrasDiagnostico(
                    'graficoTiposDiagnostico',
                    $scope.estadoGraficoTiposDiagnostico,
                    'valoresTiposDiagnostico'
                );
            }

            function dibujarGraficoElementosDiagnostico() {
                destruirGrafico(graficoElementosDiagnostico);
                graficoElementosDiagnostico = crearGraficoBarrasDiagnostico(
                    'graficoElementosDiagnostico',
                    $scope.estadoGraficoElementosDiagnostico,
                    'valoresElementosDiagnostico'
                );
            }

            function destruirGrafico(grafico) {
                if (grafico && typeof grafico.destroy === 'function') {
                    grafico.destroy();
                }
            }

            function crearGraficoBarrasDiagnostico(
                idCanvas,
                estado,
                idPlugin
            ) {
                if (!estado || !estado.hayDatos || typeof window.Chart === 'undefined') {
                    return null;
                }

                var canvas = document.getElementById(idCanvas);

                if (!canvas) {
                    return null;
                }

                var etiquetas = estado.datos.map(function (fila) {
                    return fila.etiqueta;
                });
                var valores = estado.datos.map(function (fila) {
                    return fila.total;
                });
                var totalDanios = estado.totalDanios;

                return new window.Chart(canvas.getContext('2d'), {
                    type: 'bar',
                    data: {
                        labels: etiquetas,
                        datasets: [{
                            data: valores,
                            backgroundColor: '#153e7e',
                            borderColor: '#0b2f63',
                            borderWidth: 1,
                            borderRadius: 3,
                            barPercentage: 0.72,
                            categoryPercentage: 0.86
                        }]
                    },
                    options: {
                        indexAxis: 'y',
                        responsive: true,
                        maintainAspectRatio: false,
                        color: '#153e7e',
                        layout: {
                            padding: {
                                right: 48
                            }
                        },
                        plugins: {
                            legend: {
                                display: false
                            },
                            tooltip: {
                                callbacks: {
                                    label: function (context) {
                                        var cantidad = Number(context.raw) || 0;
                                        var porcentaje = totalDanios > 0
                                            ? cantidad / totalDanios * 100
                                            : 0;

                                        return $scope.formatearNumero(cantidad, 0) +
                                            ' daños (' +
                                            $scope.formatearNumero(porcentaje, 1) +
                                            '%)';
                                    }
                                }
                            }
                        },
                        scales: {
                            x: {
                                beginAtZero: true,
                                grid: {
                                    color: '#edf0f5',
                                    drawTicks: false
                                },
                                border: {
                                    display: false
                                },
                                ticks: {
                                    display: false,
                                    precision: 0
                                }
                            },
                            y: {
                                grid: {
                                    display: false
                                },
                                ticks: {
                                    color: '#153e7e',
                                    font: {
                                        size: 10
                                    },
                                    callback: function (valor) {
                                        var etiqueta = this.getLabelForValue(valor);
                                        return etiqueta.length > 24
                                            ? etiqueta.substring(0, 24) + '…'
                                            : etiqueta;
                                    }
                                }
                            }
                        }
                    },
                    plugins: [{
                        id: idPlugin,
                        afterDatasetsDraw: function (chart) {
                            var contexto = chart.ctx;
                            var datos = chart.data.datasets[0].data;
                            var barras = chart.getDatasetMeta(0).data;

                            contexto.save();
                            contexto.fillStyle = '#153e7e';
                            contexto.font = 'bold 10px Arial';
                            contexto.textAlign = 'left';
                            contexto.textBaseline = 'middle';

                            angular.forEach(barras, function (barra, indice) {
                                contexto.fillText(
                                    $scope.formatearNumero(datos[indice], 0),
                                    barra.x + 5,
                                    barra.y
                                );
                            });

                            contexto.restore();
                        }
                    }]
                });
            }

            function obtenerConteosPorGravedad(datos) {
                var conteos = {
                    n1: 0,
                    n2: 0,
                    n3: 0,
                    n4: 0
                };

                angular.forEach(datos || [], function (elemento) {
                    var gravedad = normalizarTexto(
                        elemento.GravedadDaño ||
                        elemento.GravedadDano ||
                        elemento.Gravedad ||
                        ''
                    );
                    var cantidad = Number(elemento.Conteo) || 0;

                    if (gravedad === 'leve') {
                        conteos.n1 += cantidad;
                    } else if (gravedad === 'moderado') {
                        conteos.n2 += cantidad;
                    } else if (gravedad === 'severo') {
                        conteos.n3 += cantidad;
                    } else if (gravedad === 'critico') {
                        conteos.n4 += cantidad;
                    }
                });

                return conteos;
            }

            function normalizarTexto(texto) {
                return String(texto || '')
                    .toLowerCase()
                    .normalize('NFD')
                    .replace(/[\u0300-\u036f]/g, '')
                    .trim();
            }

            function convertirNumero(valor) {
                if (valor === null || valor === undefined || valor === '') {
                    return 0;
                }

                if (typeof valor === 'number') {
                    return isFinite(valor) ? valor : 0;
                }

                var texto = String(valor).trim();

                if (texto.indexOf(',') !== -1 && texto.indexOf('.') !== -1) {
                    texto = texto.replace(/\./g, '').replace(',', '.');
                } else {
                    texto = texto.replace(',', '.');
                }

                var numero = Number(texto);
                return isFinite(numero) ? numero : 0;
            }

            $scope.formatearNumero = function (numero, decimales) {
                var valor = Number(numero);

                if (!isFinite(valor)) {
                    return '0';
                }

                var precision = decimales === undefined || decimales === null
                    ? (Math.trunc(valor) === valor ? 0 : 1)
                    : Math.max(0, Math.min(20, Math.trunc(decimales)));
                var partes = valor.toFixed(precision).split('.');
                var parteEntera = partes[0].replace(
                    /\B(?=(\d{3})+(?!\d))/g,
                    '.'
                );

                return precision === 0
                    ? parteEntera
                    : parteEntera + ',' + partes[1];
            };

            $scope.colorVariacionDiagnostico = function () {
                var variacion = Number(
                    $scope.diagnosticoIndividual.variacionDanios
                );

                if (!$scope.diagnosticoIndividual.hayInspeccionAnterior) {
                    return '#153e7e';
                }

                if (variacion > 0) {
                    return '#ed1b35';
                }

                if (variacion < 0) {
                    return '#008000';
                }

                return '#153e7e';
            };

            $scope.colorIndicadorGravedadIndividual = function () {
                var diagnostico = $scope.diagnosticoIndividual || {};

                if (Number(diagnostico.totalN4) > 0) {
                    return '#FF0000';
                }

                if (Number(diagnostico.totalN3) > 0) {
                    return '#FF8C00';
                }

                if (Number(diagnostico.totalN2) > 0) {
                    return '#B59A00';
                }

                if (Number(diagnostico.totalN1) > 0) {
                    return '#008000';
                }

                return '#777777';
            };

            $scope.crearInspeccion = function () {
                inspeccionesService.crearInspeccionTunel($scope.InfraestructuraId)
                    .then(function (response) {
                        $scope.inspeccionId = response.data;
                        $location.url('/inspecciones/' + $routeParams.id + '/' + $scope.inspeccionId);
                    });
            };

            $scope.verCategorias = function () {
                $rootScope.inspeccionUrl = false;
                $rootScope.parteUrl = false;
                $location.path('/categorias');
            };

            $scope.volver = function () {
                $rootScope.inspeccionUrl = false;
                $rootScope.parteUrl = false;
                $location.path('/infraestructuras/6');
            };

            $scope.verInspeccion = function (idInspeccion) {
                $location.url('/inspeccionesTunelADIF/' + idInspeccion);
            };

            $scope.eliminarInspeccion = function (idInspeccion) {
                var check = confirm('¿Seguro que deseas eliminar esta inspección?');

                if (check) {
                    inspeccionesService.eliminarInspeccionTunelADIF(idInspeccion)
                        .then(function () {
                            return cargarDatosTunel();
                        });
                }
            };
        }
    ])
    .filter('filtroInspecciones', ['$filter', function ($filter) {
        return function (inspecciones, buscar) {
            if (!buscar) {
                return inspecciones;
            }

            var texto = (buscar + '').toLowerCase();

            return inspecciones.filter(function (inspeccion) {
                return ((inspeccion.Nombre || '') + '').toLowerCase().indexOf(texto) !== -1;
            });
        };
    }]);
